import React from 'react';
import './LoadingAnimation.css';

const LoadingAnimation = () => {
  return (
    <div className="loading-overlay">
      <div className="moon-container">
        <svg
          className="moon-crescent"
          viewBox="0 0 100 100"
          width="150"
          height="150"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
              <stop offset="50%" style={{ stopColor: '#FFA500', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#FF8C00', stopOpacity: 1 }} />
            </linearGradient>
          </defs>
          <path
            d="M 50,10 A 40,40 0 1,0 50,90 A 30,30 0 1,1 50,10"
            fill="url(#goldGradient)"
            className="moon-path"
          />
        </svg>
        <p className="loading-text">Logging you in…</p>
      </div>
    </div>
  );
};

export default LoadingAnimation;

